import { render, staticRenderFns } from "./DueContactLawyersSpecificBeneficiaryStep.vue?vue&type=template&id=256ff3cb&"
import script from "./DueContactLawyersSpecificBeneficiaryStep.vue?vue&type=script&lang=js&"
export * from "./DueContactLawyersSpecificBeneficiaryStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports